import React, { useRef, useCallback } from 'react';
import { SignatureElement } from './Signature-Element.js';
import { uuid } from 'uuidv4';
const style = {
  color: 'black',
  position: 'absolute',
  zIndex: '999'
};

export const DropContainer = ({ width, height, stepsSignatures, leftMargin, steps, updateStepsProps, isDragging, setIsDragging, setWriting, numberOfPages }) => {
  const dropZone = useRef();

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);
  const onDrop = (event) => {
    event.preventDefault();
    const reactFlowBounds = dropZone.current.getBoundingClientRect();
    const stepType = event.dataTransfer.getData('application/customFlow');
    if (!stepType) return;
    const step = steps.find(step => step.step.type === stepType);

    const position = {
      x: event.clientX - reactFlowBounds.left,
      y: event.clientY - reactFlowBounds.top
    };
    const newStep = {
      ...step,
      position,
      isValidated: !!step.step.automatic,
      signaturePositionId: uuid(),
      positioned: false,
      size: {
        width: 200,
        height: 100
      }
    };

    updateStepsProps({ step: newStep,
      data: {
        eventType: 'onDrop'
      } });
    setIsDragging(false);
  }
  ;

  return (
    <div
      onDragOver={onDragOver}
      ref={dropZone}
      onDrop={onDrop}
      style={{
        height: height,
        width: width,
        backgroundColor: isDragging ? 'rgba(106, 199, 199, 0.2)' : 'transparent',
        marginLeft: leftMargin,
        ...style
      }}
    >
      <div style={{ width: '100%', height: '100%' }} data-testid='dustbin'>
        {stepsSignatures.map((signature, index) => {
          return (
            <SignatureElement
              dropZoneRef={dropZone}
              key={index}
              x={signature.position.x}
              y={signature.position.y}
              step={signature}
              updateStepsProps={updateStepsProps}
              setWriting={setWriting}
              stepOrder={index}
              numberOfPages={numberOfPages}
            />
          );
        })}
      </div>
    </div>
  );
};
